import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { get, filter } from 'lodash';
import { Question, Option } from '../../../../../classes';
import { Subscription } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'question-conditions',
  templateUrl: './question-conditions.component.html',
  styleUrls: ['./question-conditions.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasicQuestionConditionsComponent implements OnInit, OnDestroy {
  @Input() readonly:boolean = true;
  @Input() question: Question;
  get parentQuestion(): Question {
    return this.question.survey.getQuestions({
      id: this.question.dependency.id
    })[0];
  }
  get preCheckedOptions(): Option[] {
    let options = get(this.parentQuestion, ['options']) || [];
    return filter(
      options,
      (o: Option) => (this.isChecked(o.id) ? true : false)
    );
  }
  get validOptions(): Option[] {
    let options = get(this.parentQuestion, ['options']) || [];
    return filter(options, o => (o.text && o.type === 'number' ? true : false));
  }
  private subscriptions: Subscription[] = [];
  constructor(private cdRef: ChangeDetectorRef) {}
  ngOnInit() {
    if (this.parentQuestion) {
      this.subscriptions.push(
        this.question.dependency.onContentUpdate.subscribe(event => {
          this.cdRef.detectChanges();
        })
      );
      if (this.parentQuestion) {
        this.subscriptions.push(
          this.parentQuestion
            .getChildTracker('options')
            .onContentUpdate.pipe(
              map(
                () =>
                  this.parentQuestion.options.filter(
                    o => o.text && o.type === 'number'
                  ).length
              ),
              distinctUntilChanged()
            )
            .subscribe(() => {
              this.cdRef.detectChanges();
            })
        );
      }
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  isChecked(optionId: string): boolean {
    let condition = {};
    condition[optionId] = true;
    return this.question.dependency.hasCondition(condition);
  }
  TrackByFn(item) {
    return item.id;
  }
}
